import React from 'react';
import { CTAButton } from './CTAButton';
export function MethodIntro() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 px-4 bg-slate-900 text-white" data-id="element-86">
      <div className="max-w-5xl mx-auto" data-id="element-87">
        <div className="text-center mb-16" data-id="element-88">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-10" data-id="element-89">
            💖 Por eso creamos el Método Calma®
          </h2>

          <div className="grid md:grid-cols-2 gap-6 text-left max-w-4xl mx-auto mb-16" data-id="element-90">
            <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700" data-id="element-91">
              <p className="text-lg md:text-xl text-slate-200" data-id="element-92">
                📚 Un sistema paso a paso para acompañarte en los momentos donde
                más lo necesitás
              </p>
            </div>
            <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700" data-id="element-93">
              <p className="text-lg md:text-xl text-slate-200" data-id="element-94">
                🧠 Herramientas prácticas para aplicar en el día a día
              </p>
            </div>
            <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700" data-id="element-95">
              <p className="text-lg md:text-xl text-slate-200" data-id="element-96">
                💬 Estrategias reales para comunicar sin gritos ni culpa
              </p>
            </div>
            <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700" data-id="element-97">
              <p className="text-lg md:text-xl text-slate-200" data-id="element-98">
                💞 Un enfoque que prioriza la conexión, no el castigo
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-20" data-id="element-99">
          <CTAButton text="👉 QUIERO EL MÉTODO CALMA AHORA" onClick={scrollToPricing} data-id="element-100" />
        </div>

        <div className="border-t border-slate-800 pt-16" data-id="element-101">
          <h3 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-102">
            💞 Por qué el Método Calma® es diferente
          </h3>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-103">
            <div className="bg-slate-800/30 p-8 rounded-2xl border border-slate-800" data-id="element-104">
              <h4 className="text-xl font-bold text-yellow-400 mb-6" data-id="element-105">
                ¿Qué vas a recibir?
              </h4>
              <ul className="space-y-4 text-slate-300" data-id="element-106">
                <li data-id="element-107">📚 Guía completa paso a paso</li>
                <li data-id="element-108">🧠 Estrategias prácticas aplicables desde el primer día</li>
                <li data-id="element-109">💬 Herramientas para mejorar la comunicación</li>
                <li data-id="element-110">🎁 Bonos que complementan todo el proceso</li>
              </ul>
            </div>

            <div className="bg-slate-800/30 p-8 rounded-2xl border border-slate-800" data-id="element-111">
              <h4 className="text-xl font-bold text-yellow-400 mb-6" data-id="element-112">
                ¿Qué vas a lograr con tu hijo?
              </h4>
              <ul className="space-y-4 text-slate-300" data-id="element-113">
                <li data-id="element-114">💞 Más conexión y menos tensión</li>
                <li data-id="element-115">💬 Mejor comunicación sin gritos</li>
                <li data-id="element-116">😌 Ambiente más tranquilo en casa</li>
                <li data-id="element-117">❤️ Relación más fuerte y saludable</li>
              </ul>
            </div>

            <div className="bg-slate-800/30 p-8 rounded-2xl border border-slate-800" data-id="element-118">
              <h4 className="text-xl font-bold text-yellow-400 mb-6" data-id="element-119">
                ¿Qué vas a lograr vos como mamá?
              </h4>
              <ul className="space-y-4 text-slate-300" data-id="element-120">
                <li data-id="element-121">✨ Sentirte más segura en tu forma de educar</li>
                <li data-id="element-122">🧠 Tener control en momentos difíciles</li>
                <li data-id="element-123">💖 Dejar atrás la culpa</li>
                <li data-id="element-124">🌟 Disfrutar más la maternidad</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}